import React, { useMemo } from "react"
import { Form } from "formik"
import { Button } from "@unlimint/admin-ui-kit"
import { useContextSelector as useCS } from "use-context-selector"

import { useTranslate } from "infrastructure/hooks/useTranslate"

import { GlobalConfigContext } from "domain/globalConfig/GlobalConfigContext"
import { globalConfigSelectors } from "domain/globalConfig/selectors"
import { dataToEntity } from "domain/team/mappers"

import { InputField } from "view/components/formik/InputField"
import { SelectField } from "view/components/formik/SelectField"

import * as S from "./styled"

export const AddUserForm = ({
  title,
  actionButtonTitle,
  isSubmitting,
  onClose,
}) => {
  const userGroups = useCS(
    GlobalConfigContext,
    globalConfigSelectors.userGroups
  )

  const userGroupsOptions = useMemo(() => {
    if (!userGroups?.data) return []
    return dataToEntity(userGroups.data)
  }, [userGroups])

  const close = useTranslate("pages.team.modals.close")
  const firstName = useTranslate("pages.team.modals.firstName")
  const lastName = useTranslate("pages.team.modals.lastName")
  const selectRolesPlaceholder = useTranslate(
    "pages.team.modals.selectRolesPlaceholder"
  )
  const roles = useTranslate("pages.team.grid.roles")
  const email = useTranslate("pages.team.grid.email")

  return (
    <Form>
      <S.Wrapper>
        <S.Title>{title}</S.Title>

        <S.FormRow>
          <InputField label={firstName} name="name" />
        </S.FormRow>
        <S.FormRow>
          <InputField label={lastName} name="surname" />
        </S.FormRow>
        <S.FormRow>
          <SelectField
            label={roles}
            name="groups"
            options={userGroupsOptions}
            placeholder={selectRolesPlaceholder}
            multiple
          />
        </S.FormRow>
        <S.FormRow>
          <InputField label={email} name="email" />
        </S.FormRow>

        <S.Buttons>
          <Button size="small" variant="outlined" onClick={onClose}>
            {close}
          </Button>
          <Button size="small" type="submit" disabled={isSubmitting}>
            {actionButtonTitle}
          </Button>
        </S.Buttons>
      </S.Wrapper>
    </Form>
  )
}
